import * as ActionTypes from '../actions'
import { loadPatients } from '../actions'



export default store => next => action => {
	console.log(action)
	if (action.type === ActionTypes.LOAD_GLOBALS_SUCCESS) {
		loadPatients()(store.dispatch)
	}
	return next(action)
}



// WEBPACK FOOTER //
// ./src/middleware/misc.js